import { isNil } from 'ramda';

import { ExtendedShortUser, User } from 'src/types/resources/User';
import { TalentSearch } from 'src/types/resources/TalentSearch';
import { formatCurrency } from 'src/utils/formatCurrency';

const TalentPresenter = {
  fullName: (talent: User): string => {
    return `${talent?.firstName} ${talent?.lastName}`;
  },
  transformSearchedToShort: (talent: TalentSearch | User): ExtendedShortUser => {
    const { fullName, id, isTalentApprovedByRevuud, avatarPicture, city, state } = talent;
    // @ts-ignore
    return {
      fullName,
      id,
      isTalentApprovedByRevuud,
      avatarPicture,
      city,
      state,
    };
  },
  hourlyRate: (talent: Pick<User, 'talentHourlyRate'>) => {
    return isNil(talent.talentHourlyRate) ? '-' : `${formatCurrency(talent.talentHourlyRate)}/hour`;
  },
};

export default TalentPresenter;
